import { Paths } from "../../../router/paths";

/** Link list and FAQ keys for the ETF screener's SEO section. */
export const ETF_FAQ_KEYS = ["q1", "q2", "q3", "q4", "q5", "q6"] as const;

export const ETF_QUICK_LINKS = [
  { key: "stockScreener", path: Paths.STOCK_SCREENER },
  { key: "topHalal", path: Paths.TOP_HALAL_STOCKS },
  { key: "readyMade", path: Paths.READY_MADE_PORTFOLIO },
  { key: "methodology", path: Paths.SHARIAH_SCREENING_METHODOLOGY },
  { key: "forBusiness", path: Paths.FOR_BUSINESS },
  { key: "academy", path: Paths.ACADEMY },
] as const;
